// Components
import Hero from "../components/layout/Hero";

// Assets
import "../assets/styles/career.css";
import heroImg from "../assets/images/career/hero.jpg";

// Hooks
import { useTranslation } from "../hooks/useTranslation";
import CareerBody from "../components/career/CareerBody";

export default function Career(params) {
    const t = useTranslation();

    return (
        <section id="careerSection">
            <Hero
                bgImage={heroImg}
                title={t("career.title")}
            />
            <CareerBody />
        </section >
    )
}